import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-1uJqE",
  "use": "add-1uJqE-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"add-1uJqE\"><path fill-rule=\"evenodd\" d=\"M4.343 11h2.314V6.635H11V4.313H6.657V0H4.343v4.313H0v2.322h4.343z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol